export default __webpack_public_path__ + "static/media/gift.ded019c1.svg";